import React from 'react';
import PreferencesDataTable from '../../../../components/common/PreferencesDataTable';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../utils/dateUtils';
import { REPORT_FIELDS } from '../hook/useBulletinImplementationReportData';
import useBulletinImplementationReportFilter from './BulletinImplementationReportFilter';

const BulletinImplementationReportTable = ({ items, totalCount, loading, lazyParams, activeFilters, onFiltersChange, sortField, sortOrder, onPage, onSort }) => {
    const { th } = useLanguage();
    const { filters, onFilter, getColumnFilterProps } = useBulletinImplementationReportFilter({ activeFilters, onFiltersChange });
    const columns = REPORT_FIELDS.map(({ field, type }) => ({
        field,
        columnKey: field,
        header: th(`bulletinImplementationReport.columns.${field}`),
        sortable: true,
        ...getColumnFilterProps(field, type),
        style: { minWidth: field === 'bayiAdi' ? '220px' : '150px' },
        body: (row) => (type === 'date' ? formatDateOnly(row[field]) || '-' : row[field] ?? '-')
    }));
    const rows = (items ?? []).map((item, index) => ({ ...item, rowKey: `${item.bultenNo ?? 'bulletin'}-${item.sasiNo ?? index}-${index}` }));
    return (
        <PreferencesDataTable
            tableKey="bulletin-implementation-report"
            columns={columns}
            value={rows}
            totalRecords={totalCount}
            className="p-datatable-gridlines"
            showGridlines
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            dataKey="rowKey"
            loading={loading}
            filterDisplay="row"
            filters={filters}
            onFilter={onFilter}
            emptyMessage={th('common.noRecords')}
            rowsPerPageOptions={[10, 20, 50, 100]}
            tableStyle={{ minWidth: '80rem' }}
            onSort={onSort}
            sortField={sortField}
            sortOrder={sortOrder}
            sortMode="single"
        />
    );
};
export default BulletinImplementationReportTable;
